import React from 'react'


const GallerySubsectionModal = ({ header, image, children }) => {

  const rootModalId = header.toString().toLowerCase() + "-subsection-root-modal"

  const clickHandler = (e) => {
    var modal = document.getElementById(rootModalId)
    modal.style.display = "flex"

  }

  const closeClickHandler = (e) => {
    var modal = document.getElementById(rootModalId);
    modal.style.display = "none";
  }

  return (<>
    <div className='gallery-subsection-modal'>
      <h4>{header}</h4>
      <img alt={header} src={image} onClick={clickHandler} />

    </div>
    <div id={rootModalId} className="modal">
      <div className="modal-content">
        <div style={{ width: "100%", textAlign: "center", alignItems:"center" }}>
          <span className="close" onClick={closeClickHandler}>&times;</span>
          <h4>{header}</h4>
        </div>
        {children}
      </div>
    </div>


  </>
  )
}

export default GallerySubsectionModal